export default async () => {
  const entries = document.querySelectorAll('.js-del-footerBenefitsWrapper');
  if (entries.length > 0) {
    const controller = await import(
      /* webpackChunkName: "DELFooterBenefitsSliderController-lib" */ '@/delonghi/Controllers/DELFooterBenefitsSlider/DELFooterBenefitsSliderController'
    );
    controller.default();
  }
};
